module.exports = __webpack_public_path__ + "img/gallery10.261b292f.jpg";